import React, {Fragment} from "react";
import {formatDate} from "../../../../shared/services/utils/utils";

function extractContent(s) {
  let span = document.createElement('span');
  span.innerHTML = s;
  return span.textContent || span.innerText;
}

export default function ({currentPrintPerformanceReport, reportAnalyticsForPerformanceReport}) {
  console.log('currentPrintPerformanceReport-reportAnalyticsForPerformanceReport', currentPrintPerformanceReport, reportAnalyticsForPerformanceReport)
  return (
    <Fragment>
    <div id="performance-report">
      <h1>{reportAnalyticsForPerformanceReport.user.getFullName()}</h1>
      {currentPrintPerformanceReport.map((pr) => (
        <div key={'per-' + pr.question}>
          <h3 key={'per-question' + pr.question}>
           {pr.question}
          </h3>
          {pr.responses.map((r, i) => (
            <p>
              <span>Phase: {r.phase.header}, Date: {formatDate(r.date)} {r.phase.fto && (<span>, {r.phase.fto.firstName} {r.phase.fto.lastName}</span>)}</span>
              <p style={{display: 'flex'}} key={'per-response' + pr.question + i}>
                <b>{r.response.notResponsive? 'NRT':( r.response.ratingLabel || r.response.rating)} </b>
                <span>{extractContent(r.response.comment || r.response.observationComment)}</span>
              </p>
            </p>
          ))}
        </div>
      ))}
    </div>
    {/*<table id="performance-report">*/}
    {/*  <thead>*/}
    {/*    <tr>*/}
    {/*      <th style={{textAlign: 'center'}} colSpan={2}>*/}
    {/*        {reportAnalyticsForPerformanceReport.user.getFullName()}*/}
    {/*      </th>*/}
    {/*    </tr>*/}
    {/*  </thead>*/}
    {/*  <tbody>*/}
    {/*  {currentPrintPerformanceReport.map((pr) => (*/}
    {/*    <Fragment key={'per-' + pr.question}>*/}
    {/*      <tr key={'per-question' + pr.question}>*/}
    {/*        <td colSpan={2} style={{fontWeight: "bold", fontSize: '1.1em'}}>{pr.question}</td>*/}
    {/*      </tr>*/}
    {/*      {pr.responses.map((r, i) => (*/}
    {/*        <tr key={'per-response' + pr.question + i}>*/}
    {/*          <td>{r.response.notResponsive? 'NRT': r.response.rating}</td>*/}
    {/*          <td>{r.response.comment || r.response.observationComment}</td>*/}
    {/*        </tr>*/}
    {/*      ))}*/}
    {/*    </Fragment>*/}
    {/*  ))}*/}
    {/*  </tbody>*/}
    {/*</table>*/}
    </Fragment>
  )
}
